import { ModalIDs } from "src/shared/config";

export const initialState: {
  [ModalIDs.SECTION_CREATION_MODAL]: {
    open: boolean;
  };
} = {
  [ModalIDs.SECTION_CREATION_MODAL]: {
    open: false,
  },
};
